// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   TextField,
//   Stack,
//   List,
//   ListItem,
//   ListItemText,
//   Tabs,
//   Tab,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem
// } from "@mui/material";
// import { Visibility, Edit, Close as CloseIcon } from "@mui/icons-material";
// import api from "../../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../../config";
// import TableComponent from "../../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
// import ClaimDetailPage from "../claimView";

// // Docs modal style (taller for tabs)
// const docsStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 600,
//   maxHeight: "80vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 0,
//   display: "flex",
//   flexDirection: "column",
// };

// // Edit modal style (your original 460px width)
// const editStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 460,
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 4,
// };

// export default function ClaimCAList() {
//   const [originalRows, setOriginalRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
//   const [selectedClaimId, setSelectedClaimId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editMode, setEditMode] = useState("verify");
//   const [openRejectDialog, setOpenRejectDialog] = useState(false);

//   // Separate filter states for both tables
//   const [feFilterVerify, setFeFilterVerify] = useState("all");
//   const [feFilterReverify, setFeFilterReverify] = useState("all");
//   const [uniqueFEs, setUniqueFEs] = useState([]);

//   const [editFormData, setEditFormData] = useState({
//     ca_assesment_amt: "",
//     ca_remark: "",
//   });

//   const [readOnlyVerifier2, setReadOnlyVerifier2] = useState({
//     ver2_assesment_amt: "",
//     ver_2_remarks: "",
//   });

//   // Docs Modal states
//   const [docsModal, setDocsModal] = useState({
//     open: false,
//     claimId: null,
//     docs: [],
//     loading: false,
//     activeTab: 0,
//   });
//   const [newDocName, setNewDocName] = useState("");

//   const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getApplicationType = (isNormal, isDelayed) => {
//     if (isNormal) return "Normal";
//     if (isDelayed) return "Delayed";
//     return "Normal"; // default
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/ca-claims-mgmt/`);
//       const unsettledClaims = res.data.filter(item => {
//         const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
//         return csb && !csb.is_settled;
//       });

//       const data = await Promise.all(unsettledClaims.map(async (item, idx) => {
//         const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
        
//         let additionalDocsData = [];
//         try {
//           const docsRes = await api.get(`/claim-mgmt/additional-docs1/${item.id}/`);
//           additionalDocsData = docsRes.data || [];
//         } catch (err) {
//           additionalDocsData = [];
//         }

//         return {
//           id: item.id,
//           slNo: idx + 1,
//           claimant_name: item.name_of_claimant1 || "-",
//           fe_name: item.fe_name || "-",
//           application_type: getApplicationType(item.is_normal, item.is_delayed),
//           ack_no: item.ack_no || "-",
//           created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
//           status: csb.is_rejected
//             ? "Rejected"
//             : csb.is_ca_verified
//             ? "CA Verified"
//             : (csb.is_verified_1 || csb.is_verified_2
//               ? "In Progress"
//               : csb.is_submited
//               ? "Submitted"
//               : "Draft"),
//           fullData: item,
//           is_ca_verified: csb.is_ca_verified || false,
//           is_ca_reverified: csb.is_ca_reverified || false,
//           is_settled: csb.is_settled || false,
//           additionalDocsData,
//         };
//       }));
      
//       // Store original data
//       setOriginalRows(data);
      
//       // Extract unique FE names for filter dropdowns
//       const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
//       setUniqueFEs(feNames);
      
//     } catch {
//       showSnackbar("Failed to load claims", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Apply filters to get table data
//   const applyFilters = (rows, feFilter) => {
//     if (feFilter === "all") {
//       return rows;
//     } else {
//       return rows.filter(row => row.fe_name === feFilter);
//     }
//   };

//   const table1Rows = applyFilters(
//     originalRows.filter(r => r.is_ca_verified === false && !r.is_settled),
//     feFilterVerify
//   );
  
//   const table2Rows = applyFilters(
//     originalRows.filter(r => r.is_ca_reverified === false && r.is_ca_verified === true && !r.is_settled),
//     feFilterReverify
//   );

//   const fetchAdditionalDocs = async (claimId) => {
//     try {
//       const res = await api.get(`/claim-mgmt/additional-docs1/${claimId}/`);
//       return res.data || [];
//     } catch (err) {
//       console.error("fetchAdditionalDocs", err);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchClaims();
//   }, []);

//   // Handle FE filter changes
//   const handleFeFilterChangeVerify = (event) => {
//     setFeFilterVerify(event.target.value);
//   };

//   const handleFeFilterChangeReverify = (event) => {
//     setFeFilterReverify(event.target.value);
//   };

//   const handleRequestDocsClick = async (claimId) => {
//     setDocsModal({ open: true, claimId, docs: [], loading: true, activeTab: 0 });
//     const docs = await fetchAdditionalDocs(claimId);
//     setDocsModal(prev => ({ ...prev, docs, loading: false }));
//   };

//   const handleDocsTabChange = (event, newValue) => {
//     setDocsModal(prev => ({ ...prev, activeTab: newValue }));
//   };

//   const handleAddDoc = async () => {
//     if (!newDocName.trim()) {
//       showSnackbar("Please enter document name", "warning");
//       return;
//     }

//     setDocsModal(prev => ({ ...prev, loading: true }));

//     try {
//       await api.post(`/claim-mgmt/additional-docs/${docsModal.claimId}/`, {
//         name: newDocName.trim(),
//       });

//       showSnackbar("Document request added successfully", "success");
//       setNewDocName("");
//       const freshDocs = await fetchAdditionalDocs(docsModal.claimId);
//       setDocsModal(prev => ({ ...prev, docs: freshDocs, loading: false }));
//     } catch (err) {
//       console.error("addDoc", err);
//       showSnackbar("Failed to add document request", "error");
//       setDocsModal(prev => ({ ...prev, loading: false }));
//     }
//   };

//   const handleEditClick = (id, mode) => {
//     const allRows = originalRows; // Use originalRows to find the claim
//     const claim = allRows.find(row => row.id === id);
//     if (!claim) return;

//     const totalObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ver2_assesment_amt: "", total_claim: "-", is_claim_amt_mached: null };

//     const remarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ver_2_remarks: "" };

//     const totalCaObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ca_assesment_amt: "" };

//     const remarkCaObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ca_remark: "" };

//     setReadOnlyVerifier2({
//       ver2_assesment_amt: totalObj.ver2_assesment_amt || "",
//       ver_2_remarks: remarkObj.ver_2_remarks || "",
//     });

//     setEditFormData({
//       ca_assesment_amt: totalCaObj.ca_assesment_amt || "",
//       ca_remark: remarkCaObj.ca_remark || "",
//     });

//     setEditMode(mode);
//     setShowEditModal(true);
//     setSelectedClaimId(id);
//   };

//   const handleViewClick = (id) => setSelectedClaimId(id);

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setReadOnlyVerifier2({ ver2_assesment_amt: "", ver_2_remarks: "" });
//   };

//   const handleBackToClaims = () => setSelectedClaimId(null);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData(prev => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleApproveClaim = async () => {
//     try {
//       let payload = {
//         ca_assesment_amt: editFormData.ca_assesment_amt,
//         ca_remark: editFormData.ca_remark,
//       };
//       if (editMode === "verify") {
//         payload.is_ca_verified = true;
//       } else {
//         payload.is_ca_reverified = true;
//       }
//       await api.patch(`/claim-mgmt/ca-claims-mgmt/${selectedClaimId}/`, payload);
//       showSnackbar("Claim approved successfully", "success");
//       setShowEditModal(false);
//       setSelectedClaimId(null);
//       // Refresh the entire table data
//       await fetchClaims();
//     } catch {
//       showSnackbar("Failed to approve claim", "error");
//     }
//   };

//   const handleRejectClaim = async () => {
//     try {
//       await api.patch(`/claim-mgmt/ca-claims-mgmt/${selectedClaimId}/`, {
//         is_rejected: true,
//         ca_remark: editFormData.ca_remark || "Claim rejected by CA",
//       });
//       showSnackbar("Claim rejected successfully", "warning");
//       setOpenRejectDialog(false);
//       setShowEditModal(false);
//       // Refresh the entire table data
//       await fetchClaims();
//     } catch {
//       showSnackbar("Failed to reject claim", "error");
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Rejected":
//         return "error";
//       case "CA Verified":
//         return "success";
//       case "In Progress":
//         return "warning";
//       case "Submitted":
//         return "info";
//       default:
//         return "default";
//     }
//   };

//   const columnsWithEdit = (mode) => [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "claimant_name", field: "claimant_name", headerName: "Name Of Claimant", width: 220 },
//     { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
//     { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
//     { id: "created", field: "created", headerName: "Applied Date", width: 150 },

//      {
//       id: "application_type",
//       field: "application_type",
//       headerName: "Application Type",
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={params.value === "Normal" ? "success" : "warning"}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     // {
//     //   id: "status",
//     //   field: "status",
//     //   headerName: "Status",
//     //   width: 140,
//     //   renderCell: (params) => (
//     //     <Chip label={params.value} color={getStatusColor(params.value)} variant="outlined" size="small" />
//     //   ),
//     // },
//     {
//       id: "request_docs",
//       field: "request_docs",
//       headerName: "Request Docs",
//       width: 140,
//       renderCell: (params) => (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleRequestDocsClick(params.row.id)}
//           sx={{ minWidth: "auto", px: 1 }}
//         >
//           Request Docs
//         </Button>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 140,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleViewClick(params.row.id)} title="View Claim">
//             <Visibility />
//           </IconButton>
//           <IconButton color="secondary" onClick={() => handleEditClick(params.row.id, mode)} title="Edit Claim">
//             <Edit />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   const selectedClaim = originalRows.find(r => r.id === selectedClaimId)?.fullData || {};
//   const totalObj = selectedClaim.total && selectedClaim.total[0]
//     ? selectedClaim.total[0]
//     : { total_claim: "-", is_claim_amt_mached: null };

//   if (selectedClaimId && !showEditModal) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button variant="contained" onClick={handleBackToClaims} sx={{ mb: 2 }}>
//           Back to Claims
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId}  claim_url={"ca-claims-mgmt"}/>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" mb={2}>CA Claim Verification</Typography>
      
//       {/* Filter for Verification Table */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-verify-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-verify-label"
//             value={feFilterVerify}
//             label="Select FE"
//             onChange={handleFeFilterChangeVerify}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={`verify-${fe}`} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilterVerify !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilterVerify}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilterVerify("all")}
//           />
//         )}
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent 
//           rows={table1Rows} 
//           columns={columnsWithEdit('verify')} 
//           manageColumnStatus 
//           enableSort="true" 
//         />
//       )}
      
//       <Typography variant="h4" mt={4} mb={2}>CA Claims Reverification</Typography>
      
//       {/* Filter for Reverification Table */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-reverify-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-reverify-label"
//             value={feFilterReverify}
//             label="Select FE"
//             onChange={handleFeFilterChangeReverify}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={`reverify-${fe}`} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilterReverify !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilterReverify}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilterReverify("all")}
//           />
//         )}
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent 
//           rows={table2Rows} 
//           columns={columnsWithEdit('reverify')} 
//           manageColumnStatus 
//           enableSort="true" 
//         />
//       )}
      
//       <SnackBarComponent open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={closeSnackbar} />

//       {/* Request Docs Modal */}
//       <Modal
//         open={docsModal.open}
//         onClose={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//       >
//         <Box sx={docsStyle}>
//           <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center">
//               <Typography variant="h6">Request Documents</Typography>
//               <IconButton
//                 onClick={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//                 size="small"
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//               <Tabs
//                 value={docsModal.activeTab}
//                 onChange={handleDocsTabChange}
//                 centered
//               >
//                 <Tab label="Add Request" />
//                 <Tab label="View All" />
//               </Tabs>
//             </Box>

//             <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
//               {docsModal.loading ? (
//                 <Box display="flex" justifyContent="center" alignItems="center" height="100%">
//                   <CircularProgress />
//                 </Box>
//               ) : docsModal.activeTab === 0 ? (
//                 <Stack spacing={2}>
//                   <TextField
//                     label="Document Name"
//                     value={newDocName}
//                     onChange={(e) => setNewDocName(e.target.value)}
//                     fullWidth
//                     placeholder="Enter document name (e.g., Bank Statement, ID Proof)"
//                   />
//                   <Box display="flex" justifyContent="flex-end" gap={1}>
//                     <Button
//                       variant="contained"
//                       onClick={handleAddDoc}
//                       disabled={!newDocName.trim()}
//                     >
//                       Add Document
//                     </Button>
//                   </Box>
//                   <Typography variant="body2" color="textSecondary">
//                     Add unlimited document requests one by one. Modal stays open.
//                   </Typography>
//                 </Stack>
//               ) : (
//                 <List sx={{ maxHeight: 400, overflow: "auto" }}>
//                   {docsModal.docs.map((doc) => (
//                     <ListItem 
//                       key={doc.id} 
//                       divider
//                       sx={{ 
//                         cursor: doc.document ? 'pointer' : 'default',
//                         '&:hover': { 
//                           backgroundColor: doc.document ? 'action.hover' : 'transparent' 
//                         } 
//                       }}
//                       onClick={() => {
//                         if (doc.document) {
//                           window.open(doc.document, '_blank');
//                         }
//                       }}
//                     >
//                       <ListItemText
//                         primary={
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Typography variant="body1" fontWeight="medium">
//                               {doc.name || "Document"}
//                             </Typography>
//                             {doc.document && (
//                               <Chip 
//                                 label="View" 
//                                 size="small" 
//                                 color="primary"
//                                 component="span"
//                                 sx={{ ml: 1 }}
//                               />
//                             )}
//                           </Box>
//                         }
//                         secondary={
//                           doc.document && doc.is_submited
//                             ? `Uploaded: ${doc.document.split("/").pop()}`
//                             : doc.is_submited
//                             ? "Submitted ✓"
//                             : "Pending ⏳"
//                         }
//                       />
//                     </ListItem>
//                   ))}
//                   {docsModal.docs.length === 0 && (
//                     <Typography variant="body2" color="textSecondary" textAlign="center" p={3}>
//                       No documents requested yet. Switch to "Add Request" tab to start.
//                     </Typography>
//                   )}
//                 </List>
//               )}
//             </Box>
//           </Box>
//         </Box>
//       </Modal>

//       {/* Edit Claim Modal - YOUR ORIGINAL STYLE */}
//       {showEditModal && (
//         <Modal open={showEditModal} onClose={handleCloseEditModal} aria-labelledby="edit-claim-modal-title">
//           <Box sx={editStyle}>
//             <Typography id="edit-claim-modal-title" variant="h6" mb={2}>
//               {editMode === "verify" ? "Verify Claim (CA)" : "Re-verify Claim (CA)"}
//             </Typography>
//             <Stack spacing={2}>
//               <Typography variant="subtitle2" color="textSecondary">Total Claim Amount</Typography>
//               <Typography variant="body1" sx={{ mb: 1 }}>{totalObj.total_claim || "-"}</Typography>
//               <Typography variant="subtitle2" color="textSecondary">Verifier 2 Assessment Amount</Typography>
//               <Typography variant="body1" sx={{ mb: 1 }}>{readOnlyVerifier2.ver2_assesment_amt || "-"}</Typography>
//               <Typography variant="subtitle2" color="textSecondary">Verifier 2 Remarks</Typography>
//               <Typography variant="body1" sx={{ mb: 2 }}>{readOnlyVerifier2.ver_2_remarks || "-"}</Typography>

//               <TextField
//                 label="CA Assessment Amount"
//                 name="ca_assesment_amt"
//                 value={editFormData.ca_assesment_amt}
//                 onChange={handleInputChange}
//                 fullWidth
//               />
//               <TextField
//                 label="CA Remarks"
//                 multiline
//                 minRows={3}
//                 name="ca_remark"
//                 value={editFormData.ca_remark}
//                 onChange={handleInputChange}
//                 fullWidth
//               />

//               <Box display="flex" justifyContent="flex-end" mt={2}>
//                 <Button variant="contained" color="success" onClick={handleApproveClaim}>Approve</Button>
//                 <Button variant="outlined" onClick={handleCloseEditModal} sx={{ ml: 1 }}>Cancel</Button>
//                 <Button variant="contained" color="error" onClick={() => setOpenRejectDialog(true)} sx={{ ml: 1 }}>Reject</Button>
//               </Box>
//             </Stack>
//           </Box>
//         </Modal>
//       )}

//       <Dialog open={openRejectDialog} onClose={() => setOpenRejectDialog(false)}>
//         <DialogTitle>Confirm Rejection</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to reject this claim?</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenRejectDialog(false)}>Cancel</Button>
//           <Button onClick={handleRejectClaim} color="error" variant="contained">Reject</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }



// pre amt val
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   TextField,
//   Stack,
//   List,
//   ListItem,
//   ListItemText,
//   Tabs,
//   Tab,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem
// } from "@mui/material";
// import { Visibility, Edit, Close as CloseIcon } from "@mui/icons-material";
// import api from "../../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../../config";
// import TableComponent from "../../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
// import ClaimDetailPage from "../claimView";
// import { useFormik } from "formik";
// import * as Yup from "yup";

// // Docs modal style (taller for tabs)
// const docsStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 600,
//   maxHeight: "80vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 0,
//   display: "flex",
//   flexDirection: "column",
// };

// // Edit modal style (your original 460px width with scroll)
// const editStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 460,
//   maxHeight: "80vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 4,
//   overflowY: "auto",
// };

// export default function ClaimCAList() {
//   const [originalRows, setOriginalRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
//   const [selectedClaimId, setSelectedClaimId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editMode, setEditMode] = useState("verify");
//   const [openRejectDialog, setOpenRejectDialog] = useState(false);

//   // Separate filter states for both tables
//   const [feFilterVerify, setFeFilterVerify] = useState("all");
//   const [feFilterReverify, setFeFilterReverify] = useState("all");
//   const [uniqueFEs, setUniqueFEs] = useState([]);

//   const [readOnlyVerifier2, setReadOnlyVerifier2] = useState({
//     ver2_assesment_amt: "",
//     ver_2_remarks: "",
//   });

//   // Court order data state
//   const [courtOrderData, setCourtOrderData] = useState({
//     ord_no: "",
//     proof: null,
//   });

//   // Docs Modal states
//   const [docsModal, setDocsModal] = useState({
//     open: false,
//     claimId: null,
//     docs: [],
//     loading: false,
//     activeTab: 0,
//   });
//   const [newDocName, setNewDocName] = useState("");

//   const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getApplicationType = (isNormal, isDelayed) => {
//     if (isNormal) return "Normal";
//     if (isDelayed) return "Delayed";
//     return "Normal"; // default
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/ca-claims-mgmt/`);
//       const unsettledClaims = res.data.filter(item => {
//         const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
//         return csb && !csb.is_settled;
//       });

//       const data = await Promise.all(unsettledClaims.map(async (item, idx) => {
//         const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
        
//         let additionalDocsData = [];
//         try {
//           const docsRes = await api.get(`/claim-mgmt/additional-docs1/${item.id}/`);
//           additionalDocsData = docsRes.data || [];
//         } catch (err) {
//           additionalDocsData = [];
//         }

//         return {
//           id: item.id,
//           slNo: idx + 1,
//           claimant_name: item.name_of_claimant1 || "-",
//           fe_name: item.fe_name || "-",
//           application_type: getApplicationType(item.is_normal, item.is_delayed),
//           ack_no: item.ack_no || "-",
//           created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
//           status: csb.is_rejected
//             ? "Rejected"
//             : csb.is_ca_verified
//             ? "CA Verified"
//             : (csb.is_verified_1 || csb.is_verified_2
//               ? "In Progress"
//               : csb.is_submited
//               ? "Submitted"
//               : "Draft"),
//           fullData: item,
//           is_ca_verified: csb.is_ca_verified || false,
//           is_ca_reverified: csb.is_ca_reverified || false,
//           is_settled: csb.is_settled || false,
//           additionalDocsData,
//         };
//       }));
      
//       // Store original data
//       setOriginalRows(data);
      
//       // Extract unique FE names for filter dropdowns
//       const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
//       setUniqueFEs(feNames);
      
//     } catch {
//       showSnackbar("Failed to load claims", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Apply filters to get table data
//   const applyFilters = (rows, feFilter) => {
//     if (feFilter === "all") {
//       return rows;
//     } else {
//       return rows.filter(row => row.fe_name === feFilter);
//     }
//   };

//   const table1Rows = applyFilters(
//     originalRows.filter(r => r.is_ca_verified === false && !r.is_settled),
//     feFilterVerify
//   );
  
//   const table2Rows = applyFilters(
//     originalRows.filter(r => r.is_ca_reverified === false && r.is_ca_verified === true && !r.is_settled),
//     feFilterReverify
//   );

//   const fetchAdditionalDocs = async (claimId) => {
//     try {
//       const res = await api.get(`/claim-mgmt/additional-docs1/${claimId}/`);
//       return res.data || [];
//     } catch (err) {
//       console.error("fetchAdditionalDocs", err);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchClaims();
//   }, []);

//   // Handle FE filter changes
//   const handleFeFilterChangeVerify = (event) => {
//     setFeFilterVerify(event.target.value);
//   };

//   const handleFeFilterChangeReverify = (event) => {
//     setFeFilterReverify(event.target.value);
//   };

//   const handleRequestDocsClick = async (claimId) => {
//     setDocsModal({ open: true, claimId, docs: [], loading: true, activeTab: 0 });
//     const docs = await fetchAdditionalDocs(claimId);
//     setDocsModal(prev => ({ ...prev, docs, loading: false }));
//   };

//   const handleDocsTabChange = (event, newValue) => {
//     setDocsModal(prev => ({ ...prev, activeTab: newValue }));
//   };

//   const handleAddDoc = async () => {
//     if (!newDocName.trim()) {
//       showSnackbar("Please enter document name", "warning");
//       return;
//     }

//     setDocsModal(prev => ({ ...prev, loading: true }));

//     try {
//       await api.post(`/claim-mgmt/additional-docs/${docsModal.claimId}/`, {
//         name: newDocName.trim(),
//       });

//       showSnackbar("Document request added successfully", "success");
//       setNewDocName("");
//       const freshDocs = await fetchAdditionalDocs(docsModal.claimId);
//       setDocsModal(prev => ({ ...prev, docs: freshDocs, loading: false }));
//     } catch (err) {
//       console.error("addDoc", err);
//       showSnackbar("Failed to add document request", "error");
//       setDocsModal(prev => ({ ...prev, loading: false }));
//     }
//   };

//   const handleEditClick = (id, mode) => {
//     const allRows = originalRows;
//     const claim = allRows.find(row => row.id === id);
//     if (!claim) return;

//     const totalObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ver2_assesment_amt: "", total_claim: "-", is_claim_amt_mached: null };

//     const remarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ver_2_remarks: "" };

//     const totalCaObj = claim.fullData.total && claim.fullData.total[0]
//       ? claim.fullData.total[0]
//       : { ca_assesment_amt: "" };

//     const remarkCaObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//       ? claim.fullData.claim_rem_base[0]
//       : { ca_remark: "" };

//     // Court order data - only if exists
//     const delayedDocs = claim.fullData.delayed_application_docs && claim.fullData.delayed_application_docs[0];
//     const courtOrderNumber = delayedDocs && delayedDocs.ord_no ? delayedDocs.ord_no : "";
//     const courtOrderDoc = delayedDocs && delayedDocs.proof ? delayedDocs.proof : null;

//     setReadOnlyVerifier2({
//       ver2_assesment_amt: totalObj.ver2_assesment_amt || "",
//       ver_2_remarks: remarkObj.ver_2_remarks || "",
//     });

//     setCourtOrderData({
//       ord_no: courtOrderNumber,
//       proof: courtOrderDoc,
//     });

//     // Reset formik form
//     formik.resetForm({
//       values: {
//         ca_assesment_amt: totalCaObj.ca_assesment_amt || "",
//         ca_remark: remarkCaObj.ca_remark || "",
//       }
//     });

//     setEditMode(mode);
//     setShowEditModal(true);
//     setSelectedClaimId(id);
//   };

//   const handleViewClick = (id) => setSelectedClaimId(id);

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setReadOnlyVerifier2({ ver2_assesment_amt: "", ver_2_remarks: "" });
//     setCourtOrderData({ ord_no: "", proof: null });
//     formik.resetForm();
//     // Clear selectedClaimId to stay on list view
//     setSelectedClaimId(null);
//   };

//   const handleBackToClaims = () => setSelectedClaimId(null);

//   // Formik validation schema
//   const validationSchema = Yup.object({
//     ca_assesment_amt: Yup.number()
//       .typeError("Must be a number")
//       .min(0, "Amount must be greater than or equal to 0")
//       .required("CA Assessment Amount is required"),
//     ca_remark: Yup.string().required("CA Remarks are required")
//   });

//   // Formik form
//   const formik = useFormik({
//     initialValues: {
//       ca_assesment_amt: "",
//       ca_remark: "",
//     },
//     validationSchema,
//     onSubmit: async (values) => {
//       try {
//         let payload = {
//           ca_assesment_amt: values.ca_assesment_amt,
//           ca_remark: values.ca_remark,
//         };
//         if (editMode === "verify") {
//           payload.is_ca_verified = true;
//         } else {
//           payload.is_ca_reverified = true;
//         }
//         await api.patch(`/claim-mgmt/ca-claims-mgmt/${selectedClaimId}/`, payload);
//         showSnackbar("Claim approved successfully", "success");
//         handleCloseEditModal();
//         await fetchClaims();
//       } catch {
//         showSnackbar("Failed to approve claim", "error");
//       }
//     },
//   });

//   const handleRejectClaim = async () => {
//     try {
//       await api.patch(`/claim-mgmt/ca-claims-mgmt/${selectedClaimId}/`, {
//         is_rejected: true,
//         ca_remark: formik.values.ca_remark || "Claim rejected by CA",
//       });
//       showSnackbar("Claim rejected successfully", "warning");
//       setOpenRejectDialog(false);
//       handleCloseEditModal();
//       await fetchClaims();
//     } catch {
//       showSnackbar("Failed to reject claim", "error");
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Rejected":
//         return "error";
//       case "CA Verified":
//         return "success";
//       case "In Progress":
//         return "warning";
//       case "Submitted":
//         return "info";
//       default:
//         return "default";
//     }
//   };

//   const columnsWithEdit = (mode) => [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "claimant_name", field: "claimant_name", headerName: "Name Of Claimant", width: 220 },
//     { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
//     { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
//     { id: "created", field: "created", headerName: "Applied Date", width: 150 },

//      {
//       id: "application_type",
//       field: "application_type",
//       headerName: "Application Type",
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={params.value === "Normal" ? "success" : "warning"}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     {
//       id: "request_docs",
//       field: "request_docs",
//       headerName: "Request Docs",
//       width: 140,
//       renderCell: (params) => (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleRequestDocsClick(params.row.id)}
//           sx={{ minWidth: "auto", px: 1 }}
//         >
//           Request Docs
//         </Button>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 140,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleViewClick(params.row.id)} title="View Claim">
//             <Visibility />
//           </IconButton>
//           <IconButton color="secondary" onClick={() => handleEditClick(params.row.id, mode)} title="Edit Claim">
//             <Edit />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   const selectedClaim = originalRows.find(r => r.id === selectedClaimId)?.fullData || {};
//   const totalObj = selectedClaim.total && selectedClaim.total[0]
//     ? selectedClaim.total[0]
//     : { total_claim: "-", is_claim_amt_mached: null };

//   if (selectedClaimId && !showEditModal) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button variant="contained" onClick={handleBackToClaims} sx={{ mb: 2 }}>
//           Back to Claims
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId} claim_url={"ca-claims-mgmt"}/>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" mb={2}>CA Claim Verification</Typography>
      
//       {/* Filter for Verification Table */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-verify-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-verify-label"
//             value={feFilterVerify}
//             label="Select FE"
//             onChange={handleFeFilterChangeVerify}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={`verify-${fe}`} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilterVerify !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilterVerify}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilterVerify("all")}
//           />
//         )}
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent 
//           rows={table1Rows} 
//           columns={columnsWithEdit('verify')} 
//           manageColumnStatus 
//           enableSort="true" 
//         />
//       )}
      
//       <Typography variant="h4" mt={4} mb={2}>CA Claims Reverification</Typography>
      
//       {/* Filter for Reverification Table */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-reverify-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-reverify-label"
//             value={feFilterReverify}
//             label="Select FE"
//             onChange={handleFeFilterChangeReverify}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={`reverify-${fe}`} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilterReverify !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilterReverify}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilterReverify("all")}
//           />
//         )}
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent 
//           rows={table2Rows} 
//           columns={columnsWithEdit('reverify')} 
//           manageColumnStatus 
//           enableSort="true" 
//         />
//       )}
      
//       <SnackBarComponent open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={closeSnackbar} />

//       {/* Request Docs Modal */}
//       <Modal
//         open={docsModal.open}
//         onClose={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//       >
//         <Box sx={docsStyle}>
//           <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center">
//               <Typography variant="h6">Request Documents</Typography>
//               <IconButton
//                 onClick={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//                 size="small"
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//               <Tabs
//                 value={docsModal.activeTab}
//                 onChange={handleDocsTabChange}
//                 centered
//               >
//                 <Tab label="Add Request" />
//                 <Tab label="View All" />
//               </Tabs>
//             </Box>

//             <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
//               {docsModal.loading ? (
//                 <Box display="flex" justifyContent="center" alignItems="center" height="100%">
//                   <CircularProgress />
//                 </Box>
//               ) : docsModal.activeTab === 0 ? (
//                 <Stack spacing={2}>
//                   <TextField
//                     label="Document Name"
//                     value={newDocName}
//                     onChange={(e) => setNewDocName(e.target.value)}
//                     fullWidth
//                     placeholder="Enter document name (e.g., Bank Statement, ID Proof)"
//                   />
//                   <Box display="flex" justifyContent="flex-end" gap={1}>
//                     <Button
//                       variant="contained"
//                       onClick={handleAddDoc}
//                       disabled={!newDocName.trim()}
//                     >
//                       Add Document
//                     </Button>
//                   </Box>
//                   <Typography variant="body2" color="textSecondary">
//                     Add unlimited document requests one by one. Modal stays open.
//                   </Typography>
//                 </Stack>
//               ) : (
//                 <List sx={{ maxHeight: 400, overflow: "auto" }}>
//                   {docsModal.docs.map((doc) => (
//                     <ListItem 
//                       key={doc.id} 
//                       divider
//                       sx={{ 
//                         cursor: doc.document ? 'pointer' : 'default',
//                         '&:hover': { 
//                           backgroundColor: doc.document ? 'action.hover' : 'transparent' 
//                         } 
//                       }}
//                       onClick={() => {
//                         if (doc.document) {
//                           window.open(doc.document, '_blank');
//                         }
//                       }}
//                     >
//                       <ListItemText
//                         primary={
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Typography variant="body1" fontWeight="medium">
//                               {doc.name || "Document"}
//                             </Typography>
//                             {doc.document && (
//                               <Chip 
//                                 label="View" 
//                                 size="small" 
//                                 color="primary"
//                                 component="span"
//                                 sx={{ ml: 1 }}
//                               />
//                             )}
//                           </Box>
//                         }
//                         secondary={
//                           doc.document && doc.is_submited
//                             ? `Uploaded: ${doc.document.split("/").pop()}`
//                             : doc.is_submited
//                             ? "Submitted ✓"
//                             : "Pending ⏳"
//                         }
//                       />
//                     </ListItem>
//                   ))}
//                   {docsModal.docs.length === 0 && (
//                     <Typography variant="body2" color="textSecondary" textAlign="center" p={3}>
//                       No documents requested yet. Switch to "Add Request" tab to start.
//                     </Typography>
//                   )}
//                 </List>
//               )}
//             </Box>
//           </Box>
//         </Box>
//       </Modal>

//       {/* Edit Claim Modal */}
//       {showEditModal && (
//         <Modal open={showEditModal} onClose={handleCloseEditModal} aria-labelledby="edit-claim-modal-title">
//           <Box sx={editStyle}>
//             <Typography id="edit-claim-modal-title" variant="h6" mb={2}>
//               {editMode === "verify" ? "Verify Claim (CA)" : "Re-verify Claim (CA)"}
//             </Typography>
//             <form onSubmit={formik.handleSubmit}>
//               <Stack spacing={2}>
//                 <Typography variant="subtitle2" color="textSecondary">Total Claim Amount</Typography>
//                 <Typography variant="body1" sx={{ mb: 1 }}>{totalObj.total_claim || "-"}</Typography>
//                 <Typography variant="subtitle2" color="textSecondary">Verifier 2 Assessment Amount</Typography>
//                 <Typography variant="body1" sx={{ mb: 1 }}>{readOnlyVerifier2.ver2_assesment_amt || "-"}</Typography>
//                 <Typography variant="subtitle2" color="textSecondary">Verifier 2 Remarks</Typography>
//                 <Typography variant="body1" sx={{ mb: 2 }}>{readOnlyVerifier2.ver_2_remarks || "-"}</Typography>

//                 {/* Court Order Fields - Only show if exists */}
//                 {courtOrderData.ord_no && (
//                   <>
//                     <Typography variant="subtitle2" color="textSecondary">Court Order Number</Typography>
//                     <TextField
//                       label="Court Order Number"
//                       value={courtOrderData.ord_no}
//                       fullWidth
//                       inputProps={{ readOnly: true }}
//                       variant="outlined"
//                     />
//                     {courtOrderData.proof && (
//                       <>
//                         <Typography variant="subtitle2" color="textSecondary">Order Document</Typography>
//                         <Box 
//                           sx={{ 
//                             p: 1.5, 
//                             bgcolor: 'action.hover', 
//                             borderRadius: 1, 
//                             border: '1px solid', 
//                             borderColor: 'divider',
//                             cursor: 'pointer',
//                             '&:hover': { bgcolor: 'action.selected' }
//                           }}
//                           onClick={() => window.open(courtOrderData.proof, '_blank')}
//                         >
//                           <Typography variant="body2" color="primary" fontWeight="medium">
//                             📄 View Order Document
//                           </Typography>
//                         </Box>
//                       </>
//                     )}
//                   </>
//                 )}

//                 <Typography variant="subtitle2" color="textSecondary">CA Assessment Amount</Typography>
//                 <TextField
//                   label="CA Assessment Amount"
//                   name="ca_assesment_amt"
//                   value={formik.values.ca_assesment_amt}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.ca_assesment_amt && Boolean(formik.errors.ca_assesment_amt)}
//                   helperText={formik.touched.ca_assesment_amt && formik.errors.ca_assesment_amt}
//                   fullWidth
//                   type="number"
//                   inputProps={{ step: "0.01", min: "0" }}
//                 />
                
//                 <Typography variant="subtitle2" color="textSecondary">CA Remarks</Typography>
//                 <TextField
//                   label="CA Remarks"
//                   name="ca_remark"
//                   multiline
//                   minRows={3}
//                   value={formik.values.ca_remark}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.ca_remark && Boolean(formik.errors.ca_remark)}
//                   helperText={formik.touched.ca_remark && formik.errors.ca_remark}
//                   fullWidth
//                 />

//                 <Box display="flex" justifyContent="flex-end" mt={2}>
//                   <Button 
//                     type="submit" 
//                     variant="contained" 
//                     color="success" 
//                     disabled={!formik.isValid || formik.isSubmitting}
//                   >
//                     Approve
//                   </Button>
//                   <Button 
//                     type="button"
//                     variant="outlined" 
//                     onClick={handleCloseEditModal} 
//                     sx={{ ml: 1 }}
//                     disabled={formik.isSubmitting}
//                   >
//                     Cancel
//                   </Button>
//                   <Button 
//                     type="button"
//                     variant="contained" 
//                     color="error" 
//                     onClick={() => setOpenRejectDialog(true)} 
//                     sx={{ ml: 1 }}
//                     disabled={formik.isSubmitting}
//                   >
//                     Reject
//                   </Button>
//                 </Box>
//               </Stack>
//             </form>
//           </Box>
//         </Modal>
//       )}

//       <Dialog open={openRejectDialog} onClose={() => setOpenRejectDialog(false)}>
//         <DialogTitle>Confirm Rejection</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to reject this claim?</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenRejectDialog(false)}>Cancel</Button>
//           <Button onClick={handleRejectClaim} color="error" variant="contained">Reject</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }


// final
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Chip,
  Modal,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemText,
  Tabs,
  Tab,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { Visibility, Edit, Close as CloseIcon } from "@mui/icons-material";
import api from "../../../api/axiosInterceptor";
import { API_BASE_URL } from "../../../config";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { LoadingSpinner } from "../../../Components/spinner/spinner";
import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
import ClaimDetailPage from "../claimView";
import { useFormik } from "formik";
import * as Yup from "yup";

// Docs modal style (taller for tabs)
const docsStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "80vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
  display: "flex",
  flexDirection: "column",
};

// Edit modal style (your original 460px width with scroll)
const editStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 460,
  maxHeight: "80vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

export default function ClaimCAList() {
  const [originalRows, setOriginalRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editMode, setEditMode] = useState("verify");
  const [openRejectDialog, setOpenRejectDialog] = useState(false);

  // Separate filter states for both tables
  const [feFilterVerify, setFeFilterVerify] = useState("all");
  const [feFilterReverify, setFeFilterReverify] = useState("all");
  const [uniqueFEs, setUniqueFEs] = useState([]);

  const [readOnlyVerifier2, setReadOnlyVerifier2] = useState({
    ver2_assesment_amt: "",
    ver_2_remarks: "",
  });

  // ✅ NEW: Store claimed amount for validation
  const [claimedAmount, setClaimedAmount] = useState(0);

  // Court order data state
  const [courtOrderData, setCourtOrderData] = useState({
    ord_no: "",
    proof: null,
  });

  // Docs Modal states
  const [docsModal, setDocsModal] = useState({
    open: false,
    claimId: null,
    docs: [],
    loading: false,
    activeTab: 0,
  });
  const [newDocName, setNewDocName] = useState("");

  const showSnackbar = (msg, sev = "info") => setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const getApplicationType = (isNormal, isDelayed) => {
    if (isNormal) return "Normal";
    if (isDelayed) return "Delayed";
    return "Normal"; // default
  };

  const fetchClaims = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/claim-mgmt/ca-claims-mgmt/`);
      const unsettledClaims = res.data.filter(item => {
        const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
        return csb && !csb.is_settled;
      });

      const data = await Promise.all(unsettledClaims.map(async (item, idx) => {
        const csb = Array.isArray(item.claim_status_base) ? item.claim_status_base[0] : item.claim_status_base;
        
        let additionalDocsData = [];
        try {
         const docsRes = await api.get(`/claim-mgmt/additional-docs1/${item.id}/`);
         additionalDocsData = docsRes.data || [];
        } catch (err) {
         additionalDocsData = [];
        }

        return {
          id: item.id,
          slNo: idx + 1,
          // claimant_name: item.name_of_claimant1 || "-",
          claimant_name:
              item.claiment_type === "self"
                ? item.name_of_claimant1 || "-"
                : item.claiment_type === "nominee"
                ? item.nominee?.[0]?.name || "-"
                : item.claiment_type === "legal_heir"
                ? item.legalHeir?.[0]?.name || "-"
                : item.name_of_claimant1 || "-",
          fe_name: item.fe_name || "-",
          application_type: getApplicationType(item.is_normal, item.is_delayed),
          ack_no: item.ack_no || "-",
          created: item.created ? new Date(item.created).toLocaleDateString("en-GB") : "-",
          status: csb.is_rejected
            ? "Rejected"
            : csb.is_ca_verified
            ? "CA Verified"
            : (csb.is_verified_1 || csb.is_verified_2
              ? "In Progress"
              : csb.is_submited
              ? "Submitted"
              : "Draft"),
          fullData: item,
          is_ca_verified: csb.is_ca_verified || false,
          is_ca_reverified: csb.is_ca_reverified || false,
          is_settled: csb.is_settled || false,
          additionalDocsData,
        };
      }));
      
      // Store original data
      setOriginalRows(data);
      
      // Extract unique FE names for filter dropdowns
      const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
      setUniqueFEs(feNames);
      
    } catch {
      showSnackbar("Failed to load claims", "error");
    } finally {
      setLoading(false);
    }
  };

  // Apply filters to get table data
  const applyFilters = (rows, feFilter) => {
    if (feFilter === "all") {
      return rows;
    } else {
      return rows.filter(row => row.fe_name === feFilter);
    }
  };

  const table1Rows = applyFilters(
    originalRows.filter(r => r.is_ca_verified === false && !r.is_settled),
    feFilterVerify
  );
  
  const table2Rows = applyFilters(
    originalRows.filter(r => r.is_ca_reverified === false && r.is_ca_verified === true && !r.is_settled),
    feFilterReverify
  );

  const fetchAdditionalDocs = async (claimId) => {
    try {
      const res = await api.get(`/claim-mgmt/additional-docs1/${claimId}/`);
      return res.data || [];
    } catch (err) {
      console.error("fetchAdditionalDocs", err);
      return [];
    }
  };

  useEffect(() => {
    fetchClaims();
  }, []);

  // Handle FE filter changes
  const handleFeFilterChangeVerify = (event) => {
    setFeFilterVerify(event.target.value);
  };

  const handleFeFilterChangeReverify = (event) => {
    setFeFilterReverify(event.target.value);
  };

  const handleRequestDocsClick = async (claimId) => {
    setDocsModal({ open: true, claimId, docs: [], loading: true, activeTab: 0 });
    const docs = await fetchAdditionalDocs(claimId);
    setDocsModal(prev => ({ ...prev, docs, loading: false }));
  };

  const handleDocsTabChange = (event, newValue) => {
    setDocsModal(prev => ({ ...prev, activeTab: newValue }));
  };

  const handleAddDoc = async () => {
    if (!newDocName.trim()) {
      showSnackbar("Please enter document name", "warning");
      return;
    }

    setDocsModal(prev => ({ ...prev, loading: true }));

    try {
      await api.post(`/claim-mgmt/additional-docs/${docsModal.claimId}/`, {
        name: newDocName.trim(),
      });

      showSnackbar("Document request added successfully", "success");
      setNewDocName("");
      const freshDocs = await fetchAdditionalDocs(docsModal.claimId);
      setDocsModal(prev => ({ ...prev, docs: freshDocs, loading: false }));
    } catch (err) {
      console.error("addDoc", err);
      showSnackbar("Failed to add document request", "error");
      setDocsModal(prev => ({ ...prev, loading: false }));
    }
  };

  // ✅ CUSTOM VALIDATION FUNCTION - CA cannot exceed claimed amount
  const validateForm = useCallback((values) => {
    const errors = {};
    
    if (values.ca_assesment_amt) {
      const assessmentAmt = parseFloat(values.ca_assesment_amt);
      if (isNaN(assessmentAmt)) {
        errors.ca_assesment_amt = 'Must be a number';
      } else if (assessmentAmt < 0) {
        errors.ca_assesment_amt = 'Amount must be greater than or equal to 0';
      } else if (assessmentAmt > claimedAmount) {
        errors.ca_assesment_amt = `Cannot exceed claimed amount (₹${claimedAmount.toLocaleString()})`;
      }
    }
    
    if (!values.ca_remark || values.ca_remark.trim() === "") {
      errors.ca_remark = "CA Remarks are required";
    }

    return errors;
  }, [claimedAmount]);

  const handleEditClick = (id, mode) => {
    const allRows = originalRows;
    const claim = allRows.find(row => row.id === id);
    if (!claim) return;

    const totalObj = claim.fullData.total && claim.fullData.total[0]
      ? claim.fullData.total[0]
      : { ver2_assesment_amt: "", total_claim: "-", is_claim_amt_mached: null };

    const remarkObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
      ? claim.fullData.claim_rem_base[0]
      : { ver_2_remarks: "" };

    const totalCaObj = claim.fullData.total && claim.fullData.total[0]
      ? claim.fullData.total[0]
      : { ca_assesment_amt: "" };

    const remarkCaObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
      ? claim.fullData.claim_rem_base[0]
      : { ca_remark: "" };

    // ✅ Set claimed amount from API data
    const parsedClaimedAmount = parseFloat(totalObj.total_claim) || 0;
    setClaimedAmount(parsedClaimedAmount);

    // Court order data - only if exists
    const delayedDocs = claim.fullData.delayed_application_docs && claim.fullData.delayed_application_docs[0];
    const courtOrderNumber = delayedDocs && delayedDocs.ord_no ? delayedDocs.ord_no : "";
    const courtOrderDoc = delayedDocs && delayedDocs.proof ? delayedDocs.proof : null;

    setReadOnlyVerifier2({
      ver2_assesment_amt: totalObj.ver2_assesment_amt || "",
      ver_2_remarks: remarkObj.ver_2_remarks || "",
    });

    setCourtOrderData({
      ord_no: courtOrderNumber,
      proof: courtOrderDoc,
    });

    // Reset formik form
    formik.resetForm({
      values: {
        ca_assesment_amt: totalCaObj.ca_assesment_amt || "",
        ca_remark: remarkCaObj.ca_remark || "",
      }
    });

    // Re-run validation with new claimed amount
    formik.validateForm();

    setEditMode(mode);
    setShowEditModal(true);
    setSelectedClaimId(id);
  };

  const handleViewClick = (id) => setSelectedClaimId(id);

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setReadOnlyVerifier2({ ver2_assesment_amt: "", ver_2_remarks: "" });
    setCourtOrderData({ ord_no: "", proof: null });
    setClaimedAmount(0); // Reset claimed amount
    formik.resetForm();
    // Clear selectedClaimId to stay on list view
    setSelectedClaimId(null);
  };

  const handleBackToClaims = () => setSelectedClaimId(null);

  // Formik form - using custom validate function
  const formik = useFormik({
    initialValues: {
      ca_assesment_amt: "",
      ca_remark: "",
    },
    validate: validateForm,
    onSubmit: async (values) => {
      try {
        let payload = {
          ca_assesment_amt: values.ca_assesment_amt,
          ca_remark: values.ca_remark,
        };
        if (editMode === "verify") {
          payload.is_ca_verified = true;
        } else {
          payload.is_ca_reverified = true;
        }
        await api.patch(`/claim-mgmt/ca-claims-mgmt/${selectedClaimId}/`, payload);
        showSnackbar("Claim approved successfully", "success");
        handleCloseEditModal();
        await fetchClaims();
      } catch {
        showSnackbar("Failed to approve claim", "error");
      }
    },
  });

  const handleRejectClaim = async () => {
    try {
      await api.patch(`/claim-mgmt/ca-claims-mgmt/${selectedClaimId}/`, {
        is_rejected: true,
        ca_remark: formik.values.ca_remark || "Claim rejected by CA",
      });
      showSnackbar("Claim rejected successfully", "warning");
      setOpenRejectDialog(false);
      handleCloseEditModal();
      await fetchClaims();
    } catch {
      showSnackbar("Failed to reject claim", "error");
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Rejected":
        return "error";
      case "CA Verified":
        return "success";
      case "In Progress":
        return "warning";
      case "Submitted":
        return "info";
      default:
        return "default";
    }
  };

  const columnsWithEdit = (mode) => [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    { id: "claimant_name", field: "claimant_name", headerName: "Name Of Claimant", width: 220 },
    { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
    { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
    { id: "created", field: "created", headerName: "Applied Date", width: 150 },

    {
      id: "application_type",
      field: "application_type",
      headerName: "Application Type",
      width: 140,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "Normal" ? "success" : "warning"}
          variant="outlined"
          size="small"
        />
      ),
    },
    {
      id: "request_docs",
      field: "request_docs",
      headerName: "Request Docs",
      width: 140,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleRequestDocsClick(params.row.id)}
          sx={{ minWidth: "auto", px: 1 }}
        >
          Request Docs
        </Button>
      ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 140,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleViewClick(params.row.id)} title="View Claim">
            <Visibility />
          </IconButton>
          <IconButton color="secondary" onClick={() => handleEditClick(params.row.id, mode)} title="Edit Claim">
            <Edit />
          </IconButton>
        </>
      ),
    },
  ];

  const selectedClaim = originalRows.find(r => r.id === selectedClaimId)?.fullData || {};
  const totalObj = selectedClaim.total && selectedClaim.total[0]
    ? selectedClaim.total[0]
    : { total_claim: "-", is_claim_amt_mached: null };

  if (selectedClaimId && !showEditModal) {
    return (
      <Box sx={{ p: 3 }}>
        <Button variant="contained" onClick={handleBackToClaims} sx={{ mb: 2 }}>
          Back to Claims
        </Button>
        <ClaimDetailPage pk={selectedClaimId} claim_url={"ca-claims-mgmt"}/>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" mb={2}>CA Claim Verification</Typography>
      
      {/* Filter for Verification Table */}
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body1" fontWeight="medium">
          Filter by FE:
        </Typography>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="fe-filter-verify-label">Select FE</InputLabel>
          <Select
            labelId="fe-filter-verify-label"
            value={feFilterVerify}
            label="Select FE"
            onChange={handleFeFilterChangeVerify}
            size="small"
          >
            <MenuItem value="all">All FEs</MenuItem>
            {uniqueFEs.map((fe) => (
              <MenuItem key={`verify-${fe}`} value={fe}>
                {fe}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {feFilterVerify !== "all" && (
          <Chip 
            label={`Showing: ${feFilterVerify}`} 
            color="primary" 
            variant="outlined"
            onDelete={() => setFeFilterVerify("all")}
          />
        )}
      </Box>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <TableComponent 
          rows={table1Rows} 
          columns={columnsWithEdit('verify')} 
          manageColumnStatus 
          enableSort="true" 
        />
      )}
      
      <Typography variant="h4" mt={4} mb={2}>CA Claims Reverification</Typography>
      
      {/* Filter for Reverification Table */}
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body1" fontWeight="medium">
          Filter by FE:
        </Typography>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="fe-filter-reverify-label">Select FE</InputLabel>
          <Select
            labelId="fe-filter-reverify-label"
            value={feFilterReverify}
            label="Select FE"
            onChange={handleFeFilterChangeReverify}
            size="small"
          >
            <MenuItem value="all">All FEs</MenuItem>
            {uniqueFEs.map((fe) => (
              <MenuItem key={`reverify-${fe}`} value={fe}>
                {fe}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {feFilterReverify !== "all" && (
          <Chip 
            label={`Showing: ${feFilterReverify}`} 
            color="primary" 
            variant="outlined"
            onDelete={() => setFeFilterReverify("all")}
          />
        )}
      </Box>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <TableComponent 
          rows={table2Rows} 
          columns={columnsWithEdit('reverify')} 
          manageColumnStatus 
          enableSort="true" 
        />
      )}
      
      <SnackBarComponent open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={closeSnackbar} />

      {/* Request Docs Modal */}
      <Modal
        open={docsModal.open}
        onClose={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
      >
        <Box sx={docsStyle}>
          <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Request Documents</Typography>
              <IconButton
                onClick={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={docsModal.activeTab}
                onChange={handleDocsTabChange}
                centered
              >
                <Tab label="Add Request" />
                <Tab label="View All" />
              </Tabs>
            </Box>

            <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
              {docsModal.loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <CircularProgress />
                </Box>
              ) : docsModal.activeTab === 0 ? (
                <Stack spacing={2}>
                  <TextField
                    label="Document Name"
                    value={newDocName}
                    onChange={(e) => setNewDocName(e.target.value)}
                    fullWidth
                    placeholder="Enter document name (e.g., Bank Statement, ID Proof)"
                  />
                  <Box display="flex" justifyContent="flex-end" gap={1}>
                    <Button
                      variant="contained"
                      onClick={handleAddDoc}
                      disabled={!newDocName.trim()}
                    >
                      Add Document
                    </Button>
                  </Box>
                  <Typography variant="body2" color="textSecondary">
                    Add unlimited document requests one by one. Modal stays open.
                  </Typography>
                </Stack>
              ) : (
                <List sx={{ maxHeight: 400, overflow: "auto" }}>
                  {docsModal.docs.map((doc) => (
                    <ListItem 
                      key={doc.id} 
                      divider
                      sx={{ 
                        cursor: doc.document ? 'pointer' : 'default',
                        '&:hover': { 
                          backgroundColor: doc.document ? 'action.hover' : 'transparent' 
                        } 
                      }}
                      onClick={() => {
                        if (doc.document) {
                          window.open(doc.document, '_blank');
                        }
                      }}
                    >
                      <ListItemText
                        primary={
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body1" fontWeight="medium">
                              {doc.name || "Document"}
                            </Typography>
                            {doc.document && (
                              <Chip 
                                label="View" 
                                size="small" 
                                color="primary"
                                component="span"
                                sx={{ ml: 1 }}
                              />
                            )}
                          </Box>
                        }
                        secondary={
                          doc.document && doc.is_submited
                            ? `Uploaded: ${doc.document.split("/").pop()}`
                            : doc.is_submited
                            ? "Submitted ✓"
                            : "Pending ⏳"
                        }
                      />
                    </ListItem>
                  ))}
                  {docsModal.docs.length === 0 && (
                    <Typography variant="body2" color="textSecondary" textAlign="center" p={3}>
                      No documents requested yet. Switch to "Add Request" tab to start.
                    </Typography>
                  )}
                </List>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Edit Claim Modal */}
      {showEditModal && (
        <Modal open={showEditModal} onClose={handleCloseEditModal} aria-labelledby="edit-claim-modal-title">
          <Box sx={editStyle}>
            <Typography id="edit-claim-modal-title" variant="h6" mb={2}>
              {editMode === "verify" ? "Verify Claim (CA)" : "Re-verify Claim (CA)"}
            </Typography>
            <form onSubmit={formik.handleSubmit}>
              <Stack spacing={2}>
                <Typography variant="subtitle2" color="textSecondary">Total Claim Amount</Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  ₹{claimedAmount.toLocaleString()} {claimedAmount === 0 && "(N/A)"}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">Verifier 2 Assessment Amount</Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>{readOnlyVerifier2.ver2_assesment_amt || "-"}</Typography>
                <Typography variant="subtitle2" color="textSecondary">Verifier 2 Remarks</Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>{readOnlyVerifier2.ver_2_remarks || "-"}</Typography>

                {/* Court Order Fields - Only show if exists */}
                {courtOrderData.ord_no && (
                  <>
                    <Typography variant="subtitle2" color="textSecondary">Court Order Number</Typography>
                    <TextField
                      label="Court Order Number"
                      value={courtOrderData.ord_no}
                      fullWidth
                      inputProps={{ readOnly: true }}
                      variant="outlined"
                    />
                    {courtOrderData.proof && (
                      <>
                        <Typography variant="subtitle2" color="textSecondary">Order Document</Typography>
                        <Box 
                          sx={{ 
                            p: 1.5, 
                            bgcolor: 'action.hover', 
                            borderRadius: 1, 
                            border: '1px solid', 
                            borderColor: 'divider',
                            cursor: 'pointer',
                            '&:hover': { bgcolor: 'action.selected' }
                          }}
                          onClick={() => window.open(courtOrderData.proof, '_blank')}
                        >
                          <Typography variant="body2" color="primary" fontWeight="medium">
                            📄 View Order Document
                          </Typography>
                        </Box>
                      </>
                    )}
                  </>
                )}

                <Typography variant="subtitle2" color="textSecondary">CA Assessment Amount</Typography>
                <TextField
                  label="CA Assessment Amount"
                  name="ca_assesment_amt"
                  value={formik.values.ca_assesment_amt}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.ca_assesment_amt && Boolean(formik.errors.ca_assesment_amt)}
                  helperText={formik.touched.ca_assesment_amt && formik.errors.ca_assesment_amt}
                  fullWidth
                  type="number"
                  inputProps={{ step: "0.01", min: "0" }}
                />
                
                <Typography variant="subtitle2" color="textSecondary">CA Remarks</Typography>
                <TextField
                  label="CA Remarks"
                  name="ca_remark"
                  multiline
                  minRows={3}
                  value={formik.values.ca_remark}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.ca_remark && Boolean(formik.errors.ca_remark)}
                  helperText={formik.touched.ca_remark && formik.errors.ca_remark}
                  fullWidth
                />

                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Button 
                    type="submit" 
                    variant="contained" 
                    color="success" 
                    disabled={!formik.isValid || formik.isSubmitting}
                  >
                    Approve
                  </Button>
                  <Button 
                    type="button"
                    variant="outlined" 
                    onClick={handleCloseEditModal} 
                    sx={{ ml: 1 }}
                    disabled={formik.isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button 
                    type="button"
                    variant="contained" 
                    color="error" 
                    onClick={() => setOpenRejectDialog(true)} 
                    sx={{ ml: 1 }}
                    disabled={formik.isSubmitting}
                  >
                    Reject
                  </Button>
                </Box>
              </Stack>
            </form>
          </Box>
        </Modal>
      )}

      <Dialog open={openRejectDialog} onClose={() => setOpenRejectDialog(false)}>
        <DialogTitle>Confirm Rejection</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to reject this claim?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRejectDialog(false)}>Cancel</Button>
          <Button onClick={handleRejectClaim} color="error" variant="contained">Reject</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
